import i18n from '@/i18n';

/**
 * Full-screen "your account is suspended" gate. Rendered by AppShell whenever
 * the global ban store is set, so it overrides the entire authed app (and works
 * even after the session has been torn down). Deliberately self-contained with
 * inline styles and the i18n singleton (v2 namespace, English fallbacks) so it
 * renders reliably regardless of surrounding providers — same approach as
 * ErrorBoundary.
 */
const msg = (key: string, fallback: string): string => {
  try {
    return i18n.t(`v2:banned.${key}`, { defaultValue: fallback });
  } catch {
    return fallback;
  }
};

const SUPPORT_EMAIL = 'support@vivideo.ai';

export function BannedPage({ reason }: { reason?: string }) {
  return (
    <div
      style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 16,
        background: '#1A1A24', color: '#fff', textAlign: 'center', padding: 24,
      }}
    >
      <div style={{ fontSize: 40 }}>🚫</div>
      <div style={{ fontSize: 20, fontWeight: 700 }}>
        {msg('title', 'Account suspended')}
      </div>
      <div style={{ fontSize: 14, opacity: 0.75, maxWidth: 420, lineHeight: 1.5 }}>
        {msg('description', 'Your account has been suspended for violating our Terms of Service. If you believe this is a mistake, please contact support.')}
      </div>
      {reason ? (
        <div style={{ fontSize: 12, opacity: 0.5, maxWidth: 420 }}>
          {msg('reasonLabel', 'Reason')}: {reason}
        </div>
      ) : null}
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        style={{
          marginTop: 8, padding: '10px 24px', borderRadius: 12,
          background: '#6C5CE7', color: '#fff', fontSize: 15, fontWeight: 600,
          textDecoration: 'none',
        }}
      >
        {msg('contact', 'Contact support')}
      </a>
    </div>
  );
}
